import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

interface service {
    name: string,
    api: string,
}

@Component
/**
 * ProfileAddresses Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of the Panel
     */
    @Prop() title!: string;

    /**
     * Raised Panel
     */
    @Prop({ type: Boolean }) raised!: boolean;

    /**
     * Show remove button
     */
    @Prop({ type: Boolean }) removable!: boolean;

    /**
     * Selectable Address
     */
    @Prop({ type: Boolean }) selectable!: boolean;

    /**
     * Division config Service
     */
    @Prop({ default: () => ({ name: 'Person', api: 'userEditProfileFetch' }) }) divisionFetchConfigService!: service;

    /**
     * Fetch Addresses Service
     */
    @Prop({ default: () => ({ name: 'Person', api: 'addressList' }) }) fetchAddressesService!: service;
}
